import BaseModel from './BaseModel';
import {ATTRIBUTE_TYPES, HitContainerAttribute} from '../../components';
import {required} from '@vuelidate/validators';

import {QmSystem} from './index';

export default class QmSubject extends BaseModel {
  constructor({id, designation = undefined, system = undefined}) {
    super(id, '', designation);
    this.designation = designation;
    this.system = system ? new QmSystem(system) : undefined;
  }

  static get fkName() {
    return 'qm_system_id';
  }

  get fkName() {
    return QmSubject.fkName;
  }

  static get apiRoute() {
    return 'qm_subject';
  }

  get listPageRoute() {
    return QmSubject.listPageRoute;
  }

  static get listPageRoute() {
    return 'qmSubjectList';
  }

  get apiRoute() {
    return QmSubject.apiRoute;
  }

  get config() {
    return QmSubject.config;
  }

  static get detailPageRoute() {
    return 'qmSubjectDetail';
  }

  get detailPageRoute() {
    return QmSubject.detailPageRoute;
  }

  static get config() {
    return {
      addable: false,
      duplicatable: false,
      importable: false,
      browsable: false,
      deletable: false,
    };
  }

  static get joinAttrsKey() {
    return ['system', 'designation'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['system', 'designation']);
  }

  static get detailAttrs() {
    return this.getAttributes(['system', 'designation']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['system', 'designation']);
  }

  static get allAttributes() {
    return {
      designation: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        validations: {required},
        tableProperties: {
          header: 'hit-app.common.designation',
          maxWidth: '2fr',
        },
      }),
      system: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_QM_SYSTEM, {
        joinPath: ['qm_system!fk_qm_subject_qm_system_id_qm_system'],
        fkToUpdate: 'qm_system_id',
        tableProperties: {
          header: 'hit-app.quality-management.system-short',
        },
      }),
      roles: new HitContainerAttribute(ATTRIBUTE_TYPES.ARRAY, {
        column: 'qualification!qm_subject_role(id)',
        transform: (objArray) => objArray.map((x) => x.id),
        tableProperties: {
          header: 'hit-base.common.role',
        },
      }),
    };
  }
}
